<template>
  <div class="">
    <edit-custom-attributes> </edit-custom-attributes>
  </div>
</template>

<script>
import EditCustomAttributes from "@/components/profile/custom-attributes/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    EditCustomAttributes,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Modifica Campo Aggiuntivo",
        path: "attributes.edit",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
    } else {
      this.notifyQueue({
        text: "Modifica Campo Aggiuntivo",
        path: "attributes.edit",
        level: 3,
      });
    }
  },
};
</script>
